import "core-js/modules/es6.regexp.match";
import _slicedToArray from "/home/runner/work/ass/ass/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.split";
import { parseDialogue } from './dialogue.js';
import { parseFormat } from './format.js';
import { parseStyle } from './style.js';
export function parse(text) {
  var tree = {
    info: {},
    styles: {
      format: [],
      style: []
    },
    events: {
      format: [],
      comment: [],
      dialogue: []
    }
  };
  var lines = text.split(/\r?\n/);
  var state = 0;
  for (var i = 0; i < lines.length; i++) {
    var line = lines[i].trim();
    if (/^;/.test(line)) continue;
    if (/^\[Script Info\]/i.test(line)) state = 1;else if (/^\[V4\+? Styles\]/i.test(line)) state = 2;else if (/^\[Events\]/i.test(line)) state = 3;else if (/^\[.*\]/.test(line)) state = 0;
    if (state === 0) continue;
    if (state === 1) {
      if (/:/.test(line)) {
        var _line$match = line.match(/(.*?)\s*:\s*(.*)/),
          _line$match2 = _slicedToArray(_line$match, 3),
          key = _line$match2[1],
          value = _line$match2[2];
        tree.info[key] = value;
      }
    }
    if (state === 2) {
      if (/^Format\s*:/i.test(line)) {
        tree.styles.format = parseFormat(line);
      }
      if (/^Style\s*:/i.test(line)) {
        tree.styles.style.push(parseStyle(line));
      }
    }
    if (state === 3) {
      if (/^Format\s*:/i.test(line)) {
        tree.events.format = parseFormat(line);
      }
      if (/^(?:Comment|Dialogue)\s*:/i.test(line)) {
        var _line$match3 = line.match(/^(\w+?)\s*:\s*(.*)/i),
          _line$match4 = _slicedToArray(_line$match3, 3),
          _key = _line$match4[1],
          _value = _line$match4[2];
        tree.events[_key.toLowerCase()].push(parseDialogue(_value, tree.events.format));
      }
    }
  }
  return tree;
}